// @ts-nocheck
/**
 * 阅读进度管理工具
 * 功能：记住每个 PDF 的阅读位置
 */

const STORAGE_KEY_PREFIX = 'pdf_reading_';

interface ReadingProgress {
  page: number;
  scale: number;
}

export function saveReadingProgress(pdfFingerprint: string, page: number, scale = 1.5): void {
  if (!pdfFingerprint) return;

  const progress = {
    page,
    scale,
    timestamp: new Date().toISOString(),
  };

  try {
    localStorage.setItem(
      `${STORAGE_KEY_PREFIX}${pdfFingerprint}`,
      JSON.stringify(progress)
    );
  } catch (error) {
    console.error('保存阅读位置失败:', error);
  }
}

export function getReadingProgress(pdfFingerprint: string): ReadingProgress | null {
  if (!pdfFingerprint) return null;

  try {
    const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}${pdfFingerprint}`);
    if (stored) {
      const progress = JSON.parse(stored);
      return {
        page: progress.page || 1,
        scale: progress.scale || 1.5,
      };
    }
  } catch (error) {
    console.error('获取阅读位置失败:', error);
  }

  return null;
}

export function clearReadingProgress(pdfFingerprint: string): void {
  if (!pdfFingerprint) return;

  try {
    localStorage.removeItem(`${STORAGE_KEY_PREFIX}${pdfFingerprint}`);
  } catch (error) {
    console.error('清除阅读位置失败:', error);
  }
}

export function clearAllReadingProgress(): void {
  try {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith(STORAGE_KEY_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  } catch (error) {
    console.error('清除所有阅读位置失败:', error);
  }
}
